// Vollea — Admin Feedback inbox
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBack, IoCheckmark, IoTrashOutline } from "react-icons/io5";
import { Card } from "../../components/ui-vollea";
import { api } from "../../lib/api";
import { C, SP, R } from "../../lib/theme";

export default function AdminFeedback() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  const load = async () => {
    try { setItems(await api.get("/admin/feedback") || []); } catch {}
  };
  useEffect(() => { load(); }, []);

  const resolve = async (id) => { await api.post(`/admin/feedback/${id}/resolve`); load(); };
  const remove = async (id) => { await api.del(`/admin/feedback/${id}`); load(); };

  const newCount = items.filter((i) => i.status === "new").length;

  return (
    <div style={{ background: C.bg, minHeight: "100vh", padding: `${SP.lg}px ${SP.lg}px 90px` }}>
      <button onClick={() => navigate("/admin")} data-testid="feedback-admin-back" style={{ color: C.text, marginBottom: SP.md }}>
        <IoChevronBack size={26} />
      </button>
      <h1 style={{ color: C.text, fontWeight: 700, fontSize: 28, margin: 0, letterSpacing: 0.5 }}>Feedback</h1>
      <div style={{ display: "flex", alignItems: "center", gap: SP.sm, marginTop: 8 }}>
        <span data-testid="feedback-new-badge" style={{ background: C.limeTint, color: C.lime, fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: R.pill, letterSpacing: 1, textTransform: "uppercase" }}>{newCount} new</span>
        <span style={{ color: C.textDim, fontSize: 13 }}>· {items.length} total</span>
      </div>

      <div style={{ marginTop: SP.xl, display: "flex", flexDirection: "column", gap: SP.md }}>
        {items.length === 0 ? (
          <div style={{ color: C.textMuted, fontSize: 13, padding: SP.lg, textAlign: "center" }}>No feedback yet.</div>
        ) : items.map((f) => (
          <Card key={f.feedback_id} testid={`feedback-${f.feedback_id}`}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: SP.sm, gap: SP.sm }}>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <span style={{ color: f.status === "new" ? C.lime : C.textDim, fontSize: 10, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>{f.status}</span>
                <span style={{ color: C.textDim, fontSize: 10 }}>·</span>
                <span style={{ color: C.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>{f.category}</span>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                {f.status === "new" && (
                  <button onClick={() => resolve(f.feedback_id)} data-testid={`feedback-resolve-${f.feedback_id}`} style={{ padding: "6px 10px", borderRadius: R.sm, background: C.limeTint, color: C.lime, fontSize: 11, fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 4, letterSpacing: 1, textTransform: "uppercase" }}>
                    <IoCheckmark size={12} /> Resolve
                  </button>
                )}
                <button onClick={() => remove(f.feedback_id)} data-testid={`feedback-delete-${f.feedback_id}`} style={{ padding: "6px 8px", borderRadius: R.sm, background: C.surface3, color: C.error }}>
                  <IoTrashOutline size={14} />
                </button>
              </div>
            </div>
            <div style={{ color: C.text, fontSize: 14, lineHeight: 1.5, whiteSpace: "pre-line" }}>{f.message}</div>
            <div style={{ color: C.textDim, fontSize: 11, marginTop: SP.sm }}>{f.name} · {f.email} · {f.role}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
